import React from 'react';
import { Button } from '@/components/ui/button';

const GoogleIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M23.52 12.27c0-.85-.08-1.67-.22-2.45H12v4.64h6.46a5.53 5.53 0 0 1-2.4 3.63v3.01h3.88c2.27-2.09 3.58-5.17 3.58-8.83z" />
    <path fill="#34A853" d="M12 24c3.24 0 5.96-1.08 7.94-2.9l-3.88-3.01c-1.08.72-2.45 1.15-4.06 1.15-3.13 0-5.78-2.11-6.72-4.96H1.29v3.12A11.99 11.99 0 0 0 12 24z" />
    <path fill="#FBBC05" d="M5.28 14.28a7.2 7.2 0 0 1 0-4.56V6.6H1.29a12 12 0 0 0 0 10.8l3.99-3.12z" />
    <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.44-3.44C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.69 1.29 6.6l3.99 3.12C6.22 6.87 8.87 4.75 12 4.75z" />
  </svg>
);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GoogleAuthButton = ({ label, testId = 'google-auth-btn' }) => {
  const handleClick = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    window.location.href = window.location.origin + '/api/auth/google/login';
  };

  return (
    <Button
      type="button"
      variant="outline"
      onClick={handleClick}
      data-testid={testId}
      className="w-full py-6 rounded-xl gap-3 bg-white dark:bg-zinc-800 border-slate-300 dark:border-zinc-700 text-slate-700 dark:text-zinc-100 hover:bg-slate-50 dark:hover:bg-zinc-700 hover:border-slate-400 dark:hover:border-zinc-600 transition-colors"
    >
      <GoogleIcon />
      <span className="text-base font-medium">{label}</span>
    </Button>
  );
};

export default GoogleAuthButton;
